module.exports = __webpack_public_path__ + "img/guangdian2x.da7a2063.gif";